import React, { useCallback, useEffect, useRef, useState } from "react";
import { CustomButton } from "../common";
import { useTranslation } from "react-i18next";
import shoppingService from "../../../service/shopping";
import RegisterService from "../../../service/Auth/Register";
import ReplicaRegService from "../../../service/Auth/Replicareg";
import ProfileService from "../../../service/profile";
import style from "./payment.module.scss";
import { Button } from "react-bootstrap";

function NewPaypalPayment(props) {
  const { t } = useTranslation();
  // let shopservice = new shoppingService();
  let registerService = new RegisterService();
  let replicaRegisterService = new ReplicaRegService();
  let profileService = new ProfileService();

  const [state, setState] = useState({
    all_amount: props.amount,
    invoice_url: "",
    paymentmethodsend: {
      payment_method: "paypal",
    },
  });

  const [renewdata, setrenewData] = useState({
    payment_method: "paypal",
    product_id: props.product,
  });

  useEffect(() => {
    setrenewData((prev) => ({
      ...prev,
      payment_method: "paypal",
      product_id: props.product,
    }));
  }, []);

  const Finishbutton = (url, e) => {
    // e.preventdefault()
    window.location.href = url;
  };

  const getRegister_Invoiceurl = async (e) => {
    // e.preventDefault();

    // e.preventDefault();

    let formData = {};
    for (const [key] of Object.entries(props.register_data)) {
      if (["sponsor", "contactInfo", "LoginInfo"].includes(key)) {
        props.register_data[key].map((items) => {
          formData[items.field_name] = items.value;
          return false;
        });
        formData["payment_method"] = "paypal";
      }
    }
    if (window.location.pathname.includes("/replica_register")) {
      await replicaRegisterService.regsiterSubmit(formData).then((res) => {
        if (res.status) {
          setState((prevState) => ({
            ...prevState,
            invoice_url: res.data.url,
          }));
        } else {
          // setState(prevState => ({
          //     ...prevState,
          //     error_msg: res.data.message,
          //     error_flag: true

          // }));

          //Invalid access token logout
          if (res.error.code === 1002) {
            props.history.push("/logout");
          }
        }
      });
    } else {
      await registerService.regsiterSubmit(formData).then((res) => {
        if (res.status) {
          setState((prevState) => ({
            ...prevState,
            invoice_url: res.data.url,
          }));
        } else {
          // setState(prevState => ({
          //     ...prevState,
          //     error_msg: res.data.message,
          //     error_flag: true

          // }));

          //Invalid access token logout
          if (res.error.code === 1002) {
            props.history.push("/logout");
          }
        }
      });
    }
  };

  const getRenew_Invoiceurl = async (e) => {

    // e.preventDefault();

    // e.preventDefault();
    let data = {
      payment_method: "paypal",
      product_id: props.renewid,
    };


    await profileService.subscriptionSubmit(data).then((res) => {
      if (res.status) {
        setState((prevState) => ({
          ...prevState,
          invoice_url: res.data.data.url,
        }));
      } else {
        if (res.error.code === 1002) {
          props.history.push("/logout");
        }
      }
    });
  };

  return (
    (
      <div className={style.MianContent}>
        <div>
          {state.invoice_url !== "" ? (
            <pre className={`alert alert-info`}>Click finish</pre>
          ) : (
            <pre className={`alert alert-info`}>Click proceed to continue</pre>
          )}

          <div className={style.Buttons}>
            {props.prevButtonClick && (
              <Button
                color="primary"
                onClick={props.prevButtonClick}
                className={`btn-pill  ${style.PrevButton}`}
                style={{ marginRight: "20px" }}
              >
                <i className="fa fa-chevron-left" />
                {t("profile.prev")} &nbsp;
              </Button>
            )}

            {/* {
            state.invoice_url !== '' ?
              <Button color="primary" onClick={(e) => { Finishbutton(state.invoice_url, e) }} className={`btn-pill ${style.NextButton}`} type="submit" style={{ marginRight: '20px' }}>
                Finish &nbsp;
              </Button> :

              <Button color="primary" onClick={() => { getRegister_Invoiceurl() }} className={`btn-pill ${style.NextButton}`} type="submit" style={{ marginRight: '20px' }}>
                Proceed &nbsp;
              </Button>


          } */}

            {window.location.pathname.includes("/register") ||
            window.location.pathname.includes("/replica_register") ? (
              state.invoice_url !== "" ? (
                <Button
                  color="primary"
                  onClick={(e) => {
                    Finishbutton(state.invoice_url, e);
                  }}
                  className={`btn-pill ${style.NextButton}`}
                  type="submit"
                  style={{ marginRight: "20px" }}
                >
                  Finish &nbsp;
                </Button>
              ) : (
                <Button
                  color="primary"
                  onClick={() => {
                    getRegister_Invoiceurl();
                  }}
                  className={`btn-pill ${style.NextButton}`}
                  type="submit"
                  style={{ marginRight: "20px" }}
                >
                  Proceed &nbsp;
                </Button>
              )
            ) : window.location.pathname.includes("/upgrade_validity") ? (
              state.invoice_url !== "" ? (
                <Button
                  color="primary"
                  onClick={(e) => {
                    Finishbutton(state.invoice_url, e);
                  }}
                  className={`btn-pill ${style.NextButton}`}
                  type="submit"
                  style={{ marginRight: "20px" }}
                >
                  Finish &nbsp;
                </Button>
              ) : (
                <Button
                  color="primary"
                  onClick={() => {
                    getRenew_Invoiceurl();
                  }}
                  className={`btn-pill ${style.NextButton}`}
                  type="submit"
                  style={{ marginRight: "20px" }}
                >
                  Proceed &nbsp;
                </Button>
              )
            ) : (
              {}
            )}
          </div>
        </div>
      </div>
    )
  );
}

export default NewPaypalPayment;
